import React, { Component } from 'react';

class VideoDiv extends Component {
    render(){
        return(<div className={`${this.props.className} lesson-video`}>
            {this.props.video.alt !== null && <h3 className="video-title">{this.props.video.alt}</h3>}
            <iframe title={this.props.video.alt}  width="100%" height="400" src={`${this.props.video.data}?rel=0&modestbranding=1&autohide=1&showinfo=0"`} frameBorder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture; autoplay; loop" allowFullScreen></iframe></div>)
    }
}
export default VideoDiv;